document.addEventListener('readystatechange', function(evt) {
  if(evt.target.readyState == 'complete') {
    updateBodyClass()
    initEffects()
  }
})

window.addEventListener('scroll', function(e) {
  updateBodyClass()
})

function updateBodyClass() {
  var body = document.body;
  if ( window.scrollY >= 70 ) {
    body.classList.add("scrolled");
  }
  else {
    body.classList.remove("scrolled");
  }
}

function initEffects() {
  var triggers = document.getElementsByClassName('animate');

  addEventListener('mousemove', this.mousemoveFn);

  for (var i = 0; i < triggers.length; i++) {
    triggers[i].addEventListener('mousemove', onMouseMove);
    triggers[i].addEventListener('mouseleave', onMouseLeave);
  }
}

function getMousePos(e) {
  var posx = 0, posy = 0;
  if (!e) var e = window.event;
  if (e.pageX || e.pageY)   {
    posx = e.pageX;
    posy = e.pageY;
  }
  else if (e.clientX || e.clientY)  {
    posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
    posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
  }
  return { x : posx, y : posy }
}

var transitions = [
  {
    translation : {x: 10, y: 10, z: 30},
    rotation : {x: 10, y: -20, z: 0}
  },
  {
    translation : {x: 10, y: 10, z: [0,-70]},
    rotation : {x: 10, y: 20, z: -2}
  },
  {
    translation : {x: 10, y: -10, z: -10},
    rotation : {x: 10, y: 20, z: 2}
  }
]

function onMouseMove(ev) {
  var doms = ev.target.getElementsByClassName('animate-child')

  for(var i = 0; i < doms.length; i++) {
    var dom = doms[i];

    var mousepos = getMousePos(ev),
      docScrolls = {left : document.body.scrollLeft + document.documentElement.scrollLeft, top : document.body.scrollTop + document.documentElement.scrollTop},
      bounds = dom.getBoundingClientRect(),
      relmousepos = { x : mousepos.x - bounds.left - docScrolls.left, y : mousepos.y - bounds.top - docScrolls.top };

    var transition = transitions[i]
    var t = transition.translation
        r = transition.rotation

    var setRange = function (obj) {
      for(var k in obj) {
        if( obj[k] == undefined ) {
          obj[k] = [0,0];
        }
        else if( typeof obj[k] === 'number' ) {
          obj[k] = [-1*obj[k],obj[k]];
        }
      }
    };

    setRange(t);
    setRange(r);

    var transforms = {
      translation : {
        x: (t.x[1]-t.x[0])/bounds.width*relmousepos.x + t.x[0],
        y: (t.y[1]-t.y[0])/bounds.height*relmousepos.y + t.y[0],
        z: (t.z[1]-t.z[0])/bounds.height*relmousepos.y + t.z[0],
      },
      rotation : {
        x: (r.x[1]-r.x[0])/bounds.height*relmousepos.y + r.x[0],
        y: (r.y[1]-r.y[0])/bounds.width*relmousepos.x + r.y[0],
        z: (r.z[1]-r.z[0])/bounds.width*relmousepos.x + r.z[0]
      }
    };

    dom.style.WebkitTransform = dom.style.transform = 'translateX(' + transforms.translation.x + 'px) translateY(' + transforms.translation.y + 'px) translateZ(' + transforms.translation.z + 'px) rotateX(' + transforms.rotation.x + 'deg) rotateY(' + transforms.rotation.y + 'deg) rotateZ(' + transforms.rotation.z + 'deg)';
  }
}

function onMouseLeave(ev) {
  var doms = ev.target.getElementsByClassName('animate-child')

  for(var i = 0; i < doms.length; i++) {
    var dom = doms[i];

    var transforms = {
      translation : {
        x: 0,
        y: 0,
        z: 0,
      },
      rotation : {
        x: 0,
        y: 0,
        z: 0
      }
    };

    dom.style.WebkitTransform = dom.style.transform = 'translateX(' + transforms.translation.x + 'px) translateY(' + transforms.translation.y + 'px) translateZ(' + transforms.translation.z + 'px) rotateX(' + transforms.rotation.x + 'deg) rotateY(' + transforms.rotation.y + 'deg) rotateZ(' + transforms.rotation.z + 'deg)';

  }
}


// WEBPACK FOOTER //
// ./app/javascript/packs/effects.js